import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAr8ftSiqXpH80DDvzqs9VQU22tNIh605Y",
    authDomain: "daddalibrary.firebaseapp.com",
    databaseURL: "https://daddalibrary-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "daddalibrary",
    storageBucket: "daddalibrary.appspot.com",
    messagingSenderId: "67962816046",
    appId: "1:67962816046:web:a535a6c17c64e77bbcc1bf"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);